import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { getValueStyle as u } from "../ActiveCouponCard/index.js";
import { Container as h, ExpiredCouponCardHeaderContainer as x, ExpiredCouponCardStamp as E, ExpiredCouponCardHeaderContentWrapper as c, ExpiredCouponTitle as m, ExpiredCouponCodeHeaderButton as S, ExpiredCouponCardRightCornerContainer as f, ExpiredCouponCodeRightCornerButton as g, SeeDealButton as s } from "./style.js";
const y = ({
  id: i,
  className: C,
  code: e,
  title: l,
  onCouponCodeClick: t,
  onActivateButtonClick: a,
  value: o,
  stampType: d,
  seeDealButtonLabel: p
}) => /* @__PURE__ */ n(h, { className: C, children: [
  /* @__PURE__ */ n(x, { children: [
    /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(
      E,
      {
        type: d,
        value: o,
        valueStyle: u(d, o)
      }
    ) }),
    /* @__PURE__ */ n(c, { children: [
      /* @__PURE__ */ r(m, { children: l }),
      e && /* @__PURE__ */ r(
        S,
        {
          title: e,
          onClick: () => t(i),
          children: e
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ r(f, { children: e ? /* @__PURE__ */ r(
    g,
    {
      title: e,
      onClick: () => t(i),
      children: e
    }
  ) : /* @__PURE__ */ r(
    s,
    {
      "aria-disabled": !0,
      onClick: () => a(i),
      title: p,
      children: p
    }
  ) })
] });
export {
  y as ExpiredCouponCard
};
